import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function PlayIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M16 1C7.72875 1 1 7.72875 1 16C1 24.2713 7.72875 31 16 31C24.2713 31 31 24.2713 31 16C31 7.72875 24.2713 1 16 1ZM21.505 18.3413L14.99 21.9087C14.5838 22.1375 14.1363 22.2513 13.6888 22.2513C13.2225 22.2513 12.755 22.1275 12.33 21.88C11.4963 21.3925 11 20.5263 11 19.5613V12.4375C11 11.4725 11.4963 10.6063 12.33 10.1188C13.1613 9.6325 14.1613 9.62375 15.0025 10.0975L21.4925 13.6513C22.3625 14.14 22.8738 15.015 22.8738 15.9988C22.8738 16.9825 22.3625 17.8575 21.5038 18.34L21.505 18.3413ZM20.375 16C20.375 16.1088 20.3025 16.1488 20.2925 16.1563L13.7775 19.725C13.7538 19.7375 13.6813 19.7775 13.5938 19.7238C13.5013 19.67 13.5013 19.59 13.5013 19.5638V12.44C13.5013 12.4138 13.5013 12.3338 13.5938 12.28C13.6275 12.26 13.6588 12.2538 13.6863 12.2538C13.7313 12.2538 13.7675 12.2738 13.79 12.2863L20.28 15.8413C20.3038 15.855 20.375 15.895 20.375 16.0038V16Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
